<div>{{errorMsg}}</div>

<!--Don't open image in another tab'-->
<!--<dx-data-grid id="gridContainer"
              [dataSource]="recsresults"
              [masterDetail]="{ enabled: false, template: 'detail' }"
              keyExpr="rowId"
              (onInitialized)="onInitialized($event)"
              (onRowExpanding)="onExpanding($event)"
              [showBorders]="true"
              [columnHidingEnabled]="true"
              (onCellClick)="ShowImageDetail($event)"
               [focusedRowEnabled]="true"
              (onContentReady)="onContentReady($event)"

              >-->

<!--Opens image in another tab-->
<button Style="color: red;" class="btn=default" *ngIf="showExportBtn" type="button" (click)="export()" title="Export - Print index copy">Export</button>
<img id="img" src="images/info.jpg" height="18" width="18"
     title="Export of search results is now available for 2 cents per record with a minimum charge of $2.00 per export"/>

<!--      <div id="list-two" class="basket">
        <app-doc-basket [docId]="record.docDetail.docID" [doctype]="record.docDetail.docType" [pagecount]="record.docDetail.pageCount" [docbeginbook]="docbeginbook" [docbeginpage]="docbeginpage" [currentindex]="currentIndex" (loaderEvent)="receiveLoader($event)"></app-doc-basket>
      </div>-->
<!--  <dx-tooltip target="#img"
              showEvent="dxhoverstart"
              hideEvent="dxhoverend">
    <div *dxTemplate="let data of 'content'">
      <span>
        <b>Export Info</b><br />
        <p>Exports are available for 2 cents per record with a minimum of $2.00 per export.</p>
      </span>
    </div>
  </dx-tooltip>-->

<dx-data-grid id="gridContainer"
              [dataSource]="recsresults"
              [remoteOperations]="remoteOps"
              [masterDetail]="{ enabled: false, template: 'detail' }"
              keyExpr="docID"
              (onContentReady)="onContentReady($event)"
              (onInitialized)="onInitialized($event)"
              (onRowExpanding)="onExpanding($event)"
              (onCellClick)="imgClicked($event)"
              [showBorders]="true"
              [allowColumnResizing]="true"
              [columnAutoWidth]="false"
              [columnMinWidth]="70">



  <!--Don't open image in another tab'-->
  <!--<dxo-state-storing [enabled]="true" type="localStorage" storageKey="storage"></dxo-state-storing>-->
  <dxo-load-panel [enabled]="true"></dxo-load-panel>
  <dxo-selection mode="single"></dxo-selection>
  <!--<dxo-state-storing [enabled]="true" type="localStorage" storageKey="storage" [savingTimeout]="500"></dxo-state-storing>-->
  <dxo-scrolling mode="virtual" columnRenderingMode="virtual" showScrollbar="always"></dxo-scrolling>
  <dxo-grouping [contextMenuEnabled]="true" [autoExpandAll]="false"></dxo-grouping>
  <dxo-group-panel [visible]="true"></dxo-group-panel>
  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxo-filter-row [visible]="showFilterRow"
                  [applyFilter]="currentFilter"></dxo-filter-row>
  <dxo-paging [enabled]="false"></dxo-paging>


  <!--<dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>-->
  <!--<dxo-search-panel [visible]="true"
                        [width]="240"
                        placeholder="Search..."></dxo-search-panel>-->
  <!-- <dxi-column dataField="unparsedName"
              caption="Business/Name">
  </dxi-column> -->

  <dxi-column dataField="recordDate"
              dataType="date"
              format="MM/dd/yyyy"
              caption="Date"
              cellTemplate="cellDateTemplate">
    <div *dxTemplate="let row of 'cellDateTemplate'; let i = index">
      <div id="div_{{row.data.docID}}_{{row.rowIndex}}" (mouseover)="mouseover($event)">
        {{row.data.recordDate | date:'MM/dd/yyyy'}}
      </div>
      <dx-tooltip target="#div_{{row.data.docID}}_{{row.rowIndex}}"
                  showEvent="dxhoverstart"
                  hideEvent="dxhoverend"
                  [contentTemplate]="infoFromServer">
        <div *dxTemplate="let data of 'infoFromServer'">
          <p>{{data}}</p>
        </div>
      </dx-tooltip>
    </div>
  </dxi-column>
  <dxi-column dataField="lname"
              caption="Last Name/Business"
              width="200">
  </dxi-column>

  <dxi-column dataField="fname"
              caption="First Name">
  </dxi-column>

  <dxi-column dataField="role"
              caption="Role">
  </dxi-column>

  <dxi-column [allowFiltering]="false"
              [allowSorting]="false"
              cellTemplate="cellTemplate"
              [width]="50"
              alignment="center"
              caption="Image">
  </dxi-column>

  <dxi-column dataField="recLandBook"
              caption="Book"
              [width]="50">
  </dxi-column>
  <dxi-column dataField="recLandPage"
              caption="Page"
              [width]="50">
  </dxi-column>
  <dxi-column dataField="docType"
              caption="Type">
  </dxi-column>
  <dxi-column dataField="revParty"
              caption="Reverse Party/Other"
              width="200">
  </dxi-column>
  <dxi-column dataField="cityTown"
              caption="City/Town">
  </dxi-column>
  <dxi-column dataField="address"
              caption="Description">
  </dxi-column>

  <!--<dxi-column [allowFiltering]="false"
              [allowSorting]="false"
              cellTemplate="cellTemplate"
              [width]="50">
  </dxi-column> -->


  <div *dxTemplate="let row of 'cellTemplate'; let i = index">
    <!--Opens image in another tab of a browser on image click-->
    <a href="javascript:;" (click)="openImage($event, row.data.docID, row.data.recLandBook, row.data.recLandPage, row.data.cityTown, row.data.docType,
                                    row.data.recordDate, row.data.idxPage, row.data.idxByPage)" class="image">
      <img id="img_{{row.data.docID}}_{{row.rowIndex}}" src="images/document-icon-blue.png" (mouseover)="mouseover($event)" />
      <dx-tooltip target="#img_{{row.data.docID}}_{{row.rowIndex}}"
                  showEvent="dxhoverstart"
                  hideEvent="dxhoverend"
                  [contentTemplate]="infoFromServer">
        <div *dxTemplate="let data of 'infoFromServer'">
          <p>{{data}}</p>
        </div>
      </dx-tooltip>
    </a>

    <!--
    <a target="_blank" [routerLink]='["/rec-address-doc-disp-pg", row.data.docID, row.data.recLandBook, row.data.recLandPage]' class="image">
      <img id="img_{{row.data.docID}}_{{row.rowIndex}}" src="images/document-icon-blue.png" (mouseover)="mouseover($event)" />
      <dx-tooltip target="#img_{{row.data.docID}}_{{row.rowIndex}}"
                  showEvent="dxhoverstart"
                  hideEvent="dxhoverend"
                  [contentTemplate]="infoFromServer">
        <div *dxTemplate="let data of 'infoFromServer'">
          <p>{{data}}</p>

        </div>
      </dx-tooltip>
    </a> -->

  </div>



  <!--<div *dxTemplate="let row of 'detail'">
    <app-rec-name-search-detail class="container-fluid" [rowData]="row" [DocID]="row.data.docID"></app-rec-name-search-detail>
  </div>-->
  <!--<div *dxTemplate="let row of 'detail'">
    <a  [routerLink]='["/rec-doc-detail-parent", row.data.docID, row.data.recLandBook, row.data.recLandPage]'>
    </a>
  </div>-->
  <!--<dxo-paging [enabled]="true" [pageSize]="15">
  </dxo-paging>
  <dxo-pager [showInfo]="true"
             infoText="Page {0} of {1} ({2} items)"
             [showNavigationButtons]="true">
  </dxo-pager>-->

</dx-data-grid>

<div class="uploader-status" *ngIf="showLoader">
  <mat-spinner diameter="50" strokeWidth="2" style="margin:0 auto;"></mat-spinner>
</div>


